import React, { lazy } from 'react';
import { Lang } from '../types';
interface PassionGalleryProps {
  lang: Lang;
}
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/n3e4VcGU6AcdakUuwhs4kR/474269091_18155386465341686_3396311504718211997_n.jpg',
  alt: 'Tattoo — floral neck piece'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qUTse56WrZKDNLmWXCqGxh/487561741_18162164260341686_3640013401475415606_n.jpg',
  alt: 'Tattoo — viking warrior sleeve'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oxaciQyseejBHKCuwadpQ9/502742069_708839911509286_3080390788585460733_n.jpg',
  alt: 'Tattoo — dragon with red flowers back piece'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/m5AUi5qzfC6e2VA1E11wQB/495112198_18165185380341686_5649159189017807173_n.jpg',
  alt: 'Tattoo — skull with purple flowers'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3kKpdQGJzXaX3E7kQMhhd2/505765886_17957198570958881_142831044616470708_n.jpg',
  alt: 'Palm Beach Tattoo & Art Expo — Julian Ospina'
}];
export function PassionGallery({
  lang
}: PassionGalleryProps) {
  const allImages = [...images, ...images];
  return <section className="pb-12 pt-2 bg-studio-bg border-b border-studio-border overflow-hidden" data-id="element-279">
      {/* Marquee container — reverse direction */}
      <div className="relative" data-id="element-280">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-studio-bg to-transparent z-10 pointer-events-none" data-id="element-281" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-studio-bg to-transparent z-10 pointer-events-none" data-id="element-282" />

        {/* Scrolling track — reverse direction */}
        <div className="flex gap-6 animate-marquee-reverse" data-id="element-283">
          {allImages.map((img, i) => <div key={i} className="flex-shrink-0 w-64 h-80 md:w-72 md:h-96 rounded-lg overflow-hidden border border-studio-border group" data-id="element-284">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-285" />
            </div>)}
        </div>
      </div>
    </section>;
}